<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<ion-app>
  <ion-menu side="start" menuId="first" contentId="main-content">
    <ion-header>
      <ion-toolbar>
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item routerLink="/">Home</ion-item>
        <ion-item routerLink="/experience">Job experience</ion-item>
        <ion-item routerLink="/cookie-policy">{{ 'cookie.title' | t }}</ion-item>
        <ion-item routerLink="/legal">Note legali</ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>

  <div id="main-content">
    <ion-header>
      <ion-toolbar class="ion-padding flex items-center justify-between">
        <ion-buttons slot="start">
          <ion-menu-button autoHide="false"></ion-menu-button>
        </ion-buttons>

        <ion-title class="text-lg md:text-xl">{{ 'home.headline' | t }}</ion-title>

        <ion-buttons slot="end" class="items-center">
          <ion-button (click)="setLang('en')" [color]="lang==='en' ? 'primary' : 'default'" size="small">EN</ion-button>
          <ion-button (click)="setLang('it')" [color]="lang==='it' ? 'primary' : 'default'" size="small">IT</ion-button>
          <a href="mailto:info@alessandrobompadre.it" class="social-mini-link" aria-label="Email">
            <ion-icon name="mail-outline"></ion-icon>
          </a>
          <a href="https://www.linkedin.com/in/alessandro-bompadre-00636a152/" target="_blank" rel="noreferrer noopener" class="social-mini-link" aria-label="LinkedIn">
            <ion-icon name="logo-linkedin"></ion-icon>
          </a>
          <ion-button (click)="toggleTheme()" title="Toggle theme">
            <ion-icon [name]="(isDark ? 'sunny' : 'moon')"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding bg-white dark:bg-slate-900 min-h-screen">
      <router-outlet></router-outlet>
    </ion-content>
  </div>
</ion-app>
